module.exports = __webpack_public_path__ + "img/macbook.a17cc4e9.png";